<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" xl="4" lg="4">
        <v-text-field
          background-color="white"
          dense
          outlined
          :label="translations.search"
          v-model="search"
          clearable
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" xl="4" lg="4">
        <v-btn color="primary" block @click="goToProspects">
          <span>
            {{ translations.label_add_producer_company }}
          </span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="loading">
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="4"
        sm="6"
        v-for="item in 24"
        :key="item"
        no-gutters
        class="py-2"
      >
        <v-card max-height="200px">
          <v-skeleton-loader type="list-item-avatar-three-line" />
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="4"
        sm="6"
        v-for="client in clients"
        :key="client.id"
        no-gutters
        class="py-2"
      >
        <FavoriteClient :client="client" @fetchData="retrieveData" />
      </v-col>
      <v-col v-if="busyGettingData">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-col>
    </v-row>
    <div class="overlayCenter" v-if="!loading && clients.length <= 0">
      <p class="text-center">{{ translations.advice_no_clients }}</p>
    </div>
  </v-container>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
//components
import FavoriteClient from "@/components/home/items/FavoriteClient.vue";
import axios from "axios";
export default {
  components: {
    FavoriteClient,
  },
  data: () => ({
    clients: [],
    loading: true,
    page: 0,
    request: null,
    busyGettingData: false,
    isMoreData: true,
    search: null,
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
  },
  async created() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
    });
  },
  async mounted() {
    this.SET_LOADER(true);
    try {
      window.addEventListener("scroll", this.handleScroll);
      let CancelToken = axios.CancelToken;
      let source = CancelToken.source();
      let response = await this.getContacts({
        page: this.page,
        search: this.search ? this.search : "",
        source: source,
      });
      if (response) {
        this.page++;
        this.clients = response.contacts;
      } else {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal, intente de nuevo !!",
          timeout: 4000,
        });
      }
    } catch (e) {
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: "Algo salio mal, intente de nuevo !!",
        timeout: 4000,
      });
    }
    this.loading = false;
    this.SET_LOADER(false);
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    goBack() {
      this.$router.back();
    },
    ...mapActions("user", ["getContacts"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations(["SET_LOADER"]),
    async handleScroll() {
      try {
        if (
          window.scrollY + window.innerHeight >=
          document.body.scrollHeight - 50
        ) {
          if (this.isMoreData) {
            if (this.busyGettingData) return;
            this.busyGettingData = true;
            let CancelToken = axios.CancelToken;
            let source = CancelToken.source();
            this.request = source;
            let response = await this.getContacts({
              page: this.page,
              search: this.search ? this.search : "",
              source: source,
            });
            if (response) {
              if (response.contacts.length > 0) {
                this.clients.push(...response.contacts);
              } else {
                this.isMoreData = false;
              }
              this.page++;
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: "Algo salio mal, intente de nuevo !!",
                timeout: 4000,
              });
            }
          }
          this.busyGettingData = false;
        }
      } catch (e) {
        this.busyGettingData = false;
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal, intente de nuevo !!",
          timeout: 4000,
        });
      }
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    goToProspects() {
      this.$router.push(`/seller-list/prospect/`);
    },
    async retrieveData() {
      let text = this.search ? this.search : "";
      this.clients = [];
      this.page = 0;
      this.isMoreData = true;
      this.loading = true;
      this.scrollTop();
      try {
        if (this.request != null) {
          this.request.cancel("SE CANCELO");
          let CancelToken = axios.CancelToken;
          let source = CancelToken.source();
          this.request = source;
        } else {
          let CancelToken = axios.CancelToken;
          let source = CancelToken.source();
          this.request = source;
        }
        let response = await this.getContacts({
          page: this.page,
          search: text,
          source: this.request,
        });
        if (response && response.contacts) {
          if (response.contacts.length > 0) {
            this.clients = response.contacts;
          } else {
            this.isMoreData = false;
          }
          this.page++;
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal, intente de nuevo !!",
          timeout: 4000,
        });
      }
      this.loading = false;
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    async search() {
      await this.retrieveData();
    },
  },
};
</script>

<style scoped>
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 50%;
  left: 20%;
  right: 20%;
  bottom: 50%;
  z-index: 1;
  position: absolute;
}
</style>
